import { Injectable } from '@angular/core';
import { InputsTableConfig } from '../../../models/input.interface';

@Injectable({
  providedIn: 'root'
})
export class InputsTableService {
  private tableConfig: InputsTableConfig;

  public getTableConfig(): InputsTableConfig {
    return this.tableConfig;
  }

  public setTableConfig(config: InputsTableConfig): void {
    this.tableConfig = config;
  }
}


